import React from 'react';
import type { RadioButtonGroupLabelProps } from '../interfaces';

class RadioButtonGroupLabel extends React.PureComponent<RadioButtonGroupLabelProps> {
  render() {
    if (this.props.inline) {
      return null;
    }

    return <span className={'radio-button-label'}>{this.props.label}</span>;
  }
}

export default RadioButtonGroupLabel;
